import React, { useState, useRef, useEffect, useContext } from "react";
import { IoChevronForwardOutline } from "react-icons/io5";
import "../../../../../node_modules/video-react/dist/video-react.css"; // import css
import { Player, ControlBar } from "video-react";
import DeletePopup from "./DeletePopup";
import DeleteBookmark from "./DeleteBookmark";
import { Document, Page } from "react-pdf";
import { pdfjs } from "react-pdf";
import BookMarkNote from "./BookMarkNote";
import AddBookmark from "./AddBookmark";
import EditNotePopup from "./EditNotePopup";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "../../../../axios";
import { IP } from "../../../../internalServer";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { Button } from "semantic-ui-react";
import Overview from "./overview";
import Notes from "./notes";
import Bookmark from "./Bookmark";
import { FaBookmark, FaExpand } from "react-icons/fa";
import HeaderContext from "../../../../HeaderContext";
import PlayerComponent from "../../../../midea_viewer/playerComponent";
import MediaRenderer from "./MediaRenderer";
import { formatSeconds } from "../../../../utils/helper";
import { shortenParagraph } from "../../../../utils/Engagement";
import QuizPopup from "./QuizPopup";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/3.6.172/pdf.worker.js`;

export default function LibraryChapterDetails() {
  const { index, isContinue } = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [contentData, setContentData] = useState([]);
  const [clickedContent, setClickedContent] = useState(null);
  const [userDetail, setUserDetail] = useState();
  const poster = "";

  const { handleProfile } = useContext(HeaderContext);

  const [openSubject, setOpenSubject] = useState({
    Class: false,
    ChapterContent: false,
    ChapterContent2: false,
    deletePopupNote: false,
    deletePopupBookmark: false,
    chapterContentDetailsLeft: "audio",
    editeNotePopUp: false,
  });
  const [groupId, setGroupId] = useState("");
  useEffect(() => {
    let detail = JSON.parse(localStorage.getItem("breathForStudent"));
    setUserDetail(detail);
    let grpId = localStorage.getItem("GroupId");
    setGroupId(grpId);
  }, []);
  const handelCLick1 = async () => {
    let res = await axios.get(
      `/cm/library/book/getLeftPaneByChapterId?chapter_id=${state.chapter_id}`
    );
    setContentData(res?.data?.data[0]?.chapterCategoryID);
    if (openSubject.Class) {
      setOpenSubject({
        ...openSubject,
        Class: false,
      });
    } else {
      setOpenSubject({
        ...openSubject,
        Class: true,
      });
    }
  };
  useEffect(() => {
    handelCLick1();
  }, []);
  const [contentOpenState, setContentOpenState] = useState([]);
  useEffect(() => {
    setContentOpenState((prevState) => {
      const newState = new Array(contentData.length).fill(false);
      if (isContinue === "0") {
        newState[0] = true;
        newState[1] = true;
      } else {
        contentData.forEach((object, index) => {
          object?.contentInfoID.forEach((obj, index1) => {
            if (obj.id === lastSeen?.contentInfo?.id) {
              let obj1 = contentData[index]?.contentInfoID[index1];
              newState[index] = true;
              setClickedContent(obj1);
            }
          });
        });
      }
      return newState;
    });
  }, [contentData]);
  useEffect(() => {
    let obj = contentData[0]?.contentInfoID[0];
    setClickedContent(obj);
  }, [contentData]);

  const handelCLick2 = (index) => {
    const updatedOpenState = [...contentOpenState];
    updatedOpenState[index] = !updatedOpenState[index];
    setContentOpenState(updatedOpenState);
  };
  const [activeHeader, setActiveHeader] = useState("Overview");
  // codeediter
  const handleCloseNoteDeltePopup = () => {
    setOpenSubject({
      ...openSubject,
      deletePopupNote: false,
    });
  };
  const handleCloseNoteEditPopup = () => {
    setOpenSubject({
      ...openSubject,
      editeNotePopUp: false,
    });
  };

  const handleCloseBookmarkDeltePopup = () => {
    setOpenSubject({
      ...openSubject,
      deletePopupBookmark: false,
    });
  };

  // editing bookmark text
  const [isEditing, setIsEditing] = useState(false);

  const [editBookmarkIndex, setEditBookmarkIndex] = useState(null);

  const handleEditClick = (index) => {
    setEditBookmarkIndex(index);
  };

  const handleSaveClick = () => {
    setIsEditing(false);
  };
  const [clickedSubject, setClickedSubject] = useState("");
  const [clickedSubjectId, setClickedSubjectId] = useState("");
  const [clickedBook, setClickedBook] = useState({});
  const [clickedChapterName, setClickedChapterName] = useState();
  const [componentRerenderFlag, setComponentRerenderFlag] = useState(false);

  const [clickedChapterId, setClickedChapterId] = useState();
  const [lastSeen, setLastSeen] = useState([]);
  const [openQuizPopup, setOpenQuizPopup] = useState(false);

  useEffect(() => {
    let res = localStorage.getItem("LibSubj");
    let res2 = localStorage.getItem("LibSubjId");
    let res3 = JSON.parse(localStorage.getItem("LastSeen"));
    setClickedSubjectId(res2);
    setClickedSubject(res);
    setLastSeen(res3);
    let res1 = JSON.parse(localStorage.getItem("clickedChap"));
    if (res1) {
      setClickedBook(res1);
      setClickedChapterName(res1?.chapterData[index]?.chapterName);
      setClickedChapterId(res1?.chapterData[index]?.id);
    }
  }, []);
  const helper = (a) => {
    const str = a;
    const startsWithDot = str?.startsWith(".");
    if (startsWithDot) {
      let p = a.replace(/^\./, "");
      p = IP + p;
      return p;
    } else {
      return a;
    }
  };
  function formatDate(inputDate) {
    const date = new Date(inputDate);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }
  const [numPages, setNumPages] = useState(null);
  const [contentNote, setContentNote] = useState([]);
  useEffect(() => {
    const helper = async () => {
      setContentNote([]);
      if (userDetail?.id && clickedContent?.id) {
        let res = await axios.get(
          `/cm/library/book/getUserNotesByUserIDAndContentInfoID?user_id=${userDetail?.id}&contentInfo_id=${clickedContent?.id}`
        );
        setContentNote(res.data.data.notesID);
      }
    };
    if (clickedContent) {
      helper();
    }
  }, [clickedContent]);

  useEffect(() => {
    if (contentData.length > 0) {
      const initialState = new Array(contentData.length).fill(false);
      initialState[0] = true;
      initialState[1] = true;
      setContentOpenState(initialState);
    }
  }, [contentData]);

  const [clickedNote, setClickedNotes] = useState([]);
  const [jumpToLastSeenTime, setJumpToLastSeenTime] = useState("")
  const playerRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);
  const handleTimeUpdate = () => {
    setCurrentTime(playerRef.current.getCurrentTime());
  };
  const handleTimeUpdateVdoCiphyer = () => {
    if (playerRef.current) {
      const { currentTime } = playerRef.current.getState().player;
      setCurrentTime(currentTime);
    }
  };

  const [bookmarks, setBookmarks] = useState();
  const handleBookmarkClick = () => {
    if (playerRef.current) {
      // const currentTime = playerRef.current.getCurrentTime();
      const currentTime = playerRef.current.getCurrentTime();
      setBookmarks(currentTime);
    }
  };
  const handleJumpToTime = (time) => {
    if (playerRef.current) {
      playerRef.current.jumpToTime(time);
      // playerRef.current.playVideo();
    }
  };
  const [addBookmark, setAddBookmark] = useState(false);
  const [clickedBookmark, setClickedBookmark] = useState();
  const [currentPage, setCurrentPage] = useState(1);

  const handleNextPage = () => {
    if (currentPage < numPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const getLastSeen = async () => {
    try {
      const res = await axios.get(
        `/cm/library/book/getUserLastSeenStampByUserId?user_id=${detail?.id}&subject_id=${state.subject_id}&standardID=${detail?.standard?.id}&sectionID=${detail?.section?.id}&timetableSessionID=${detail?.timetable_session?.id}`
      );
      const data = res.data.data;
      setLastSeen(data);
      setJumpToLastSeenTime(res.data.data.lastSeenStamp)
      setTimeout(() => {
        handleJumpToTime(res.data.data.lastSeenStamp)
      }, 1000)
    } catch (err) {
      console.error("Error fetching last seen data: ", err);
    }
  };
  useEffect(() => {
    getLastSeen()
  }, [])

  let detail = JSON.parse(localStorage.getItem("breathForStudent"));

  const handleUserLastSeen = async (currentTime) => {
    let body = {
      lastSeenStamp: parseInt(currentTime) || currentPage,
      contentInfo: clickedContent?.id,
      userID: userDetail?.id,
      bookID: clickedBook?.id,
      chapterID: clickedChapterId,
      subjectID: clickedSubjectId,
      standardID: detail?.standard?.id,
      sectionID: detail?.section?.id,
      timetableSessionID: detail?.timetable_session?.id,
    };
    try {
      let res = await axios.post(`/school/library/userLastSeen/create`, body);
    } catch (error) {
      console.log(error);
    }
  };
  const [type, setType] = useState("");
  useEffect(() => {
    const helper = () => {
      contentData.forEach((object) => {
        object?.contentInfoID.forEach((obj) => {
          if (obj.id === lastSeen?.contentInfo?.id) {
            if (isContinue === 1) {
            }
          }
        });
      });
    };
    helper();
    getLastSeen();
  }, []);

  const toggleFullScreen = () => {
    const element = document.getElementById("fullScreenContent");
    const isFullScreen = document.fullscreenElement;

    if (element && !isFullScreen) {
      try {
        element.requestFullscreen();
      } catch (error) {
        console.error("Failed to enter fullscreen mode:", error);
      }
    } else {
      try {
        document.exitFullscreen();
      } catch (error) {
        console.error("Failed to exit fullscreen mode:", error);
      }
    }
  };


  if (clickedContent == null || clickedContent == undefined) return;
  return (
    <div className="">
      {/* <div className="HeaderDetailContainer d-flex justify-content-between">
        <div className="d-flex gap-3 align-items-center">
          <img
            style={{ cursor: "pointer" }}
            src="/HwImg/backArrow.png"
            alt=""
            onClick={() => {
              navigate(-1);
            }}
          />

          <div className="HeaderTitle" style={{ cursor: "pointer" }}>
            Library
          </div>
        </div>
      </div> */}

      <div className="row">
        <div className="Total_decription_rightSide col-sm-4">
          <div
            className="flex justify-between items-center"
          >
            <div className="d-flex gap-1 align-items-center">
              <div
                className="path_subject_library"
                onClick={() => {
                  navigate(-2);
                }}
              >
                Library{" "}
              </div>
              <IoChevronForwardOutline />
              <div
                className="path_subject_library"
                title={clickedSubject}
                onClick={() => {
                  navigate(-1);
                }}
              >
                {shortenParagraph(clickedSubject, 7)}
              </div>
              <IoChevronForwardOutline />
              <div className="path_subject_library" title={clickedBook?.name}>{shortenParagraph(clickedBook?.name, 20)}</div>
            </div>
            <button className="quiz-button" disabled={contentData.length === 0} onClick={() => setOpenQuizPopup(true)}>Take Quiz</button>
          </div>
          {
            <div
              className="d-flex gap-2 justify-content-between total_chapter_dropdown"
              onClick={handelCLick1}
            >
              <div className="chapter_dropdown_heder font-bold">{clickedChapterName}</div>
              {openSubject.Class ? (
                <img src="/LibraryImg/UpwordArrow.svg" alt="arrow logo" style={{ marginLeft: "10px" }}></img>
              ) : (
                <img src="/LibraryImg/downArrow.svg" alt="arrow logo"></img>
              )}
            </div>
          }
          {openSubject.Class && (
            <div>
              <div className="mt-4">
                {contentData.length > 0 &&
                  contentData.map((obj, index) => (
                    <div>
                      <div
                        className="d-flex justify-content-between"
                        onClick={() => {
                          handelCLick2(index);
                        }}
                      >
                        <div className="d-flex gap-3">
                          <span className="FirstCircle ">1.{index + 1}</span>
                          <div>
                            <div className="text_books">{obj.CategoryName}</div>
                            <div className="textBokkSubcontain ">
                              {obj.contentInfoID.length} study materials
                            </div>
                          </div>
                        </div>
                        <div>
                          {contentOpenState[index] ? (
                            <img
                              src="/ContentM_images/UpwordArrow.svg"
                              alt="arrow logo"
                            ></img>
                          ) : (
                            <img
                              src="/ContentM_images/downArrow.svg"
                              alt="arrow logo"
                            ></img>
                          )}
                        </div>
                      </div>
                      {!contentOpenState[index] &&
                        index !== contentOpenState.length - 1 && (
                          <div
                            style={{
                              borderLeft: "3px solid orange",
                              height: "10px"
                            }}
                            className="hell"
                          ></div>
                        )}
                      {contentOpenState[index] && (
                        <div className="hell">
                          {contentData[index]?.contentInfoID?.length > 0 &&
                            contentData[index]?.contentInfoID?.map(
                              (obj, index) => (
                                <div
                                  style={{ cursor: "pointer" }}
                                  className="d-flex justify-content-between flex-wrap align-items-center"
                                  onClick={() => {
                                    setClickedContent(obj);
                                  }}
                                >
                                  <div className="d-flex gap-2 mb-1 fileData">
                                    <img
                                      src="/ContentM_images/ThreeBlackLine.svg"
                                      alt="List logo"
                                    ></img>
                                    {obj?.fileInfo?.fileType === "audio" && (
                                      <img
                                        src="/ContentM_images/SoundIcon.svg"
                                        alt="sound logo"
                                        className="iconSTyl"
                                      ></img>
                                    )}
                                    {obj?.fileInfo?.fileType === "mp3" && (
                                      <img
                                        src="/ContentM_images/SoundIcon.svg"
                                        alt="sound logo"
                                        className="iconSTyl"
                                      ></img>
                                    )}
                                    {obj?.fileInfo?.fileType === "pdf" && (
                                      <img
                                        src="/ContentM_images/PdfBlackIcon.svg"
                                        alt="sound logo"
                                        className="iconSTyl"
                                      ></img>
                                    )}
                                    {obj?.fileInfo?.fileType === "e-book" && (
                                      <img
                                        src="/ContentM_images/PdfBlackIcon.svg"
                                        alt="sound logo"
                                        className="iconSTyl"
                                      ></img>
                                    )}
                                    {obj?.fileInfo?.fileType === "img" && (
                                      <img
                                        src="/ContentM_images/PdfBlackIcon.svg"
                                        alt="sound logo"
                                        className="iconSTyl"
                                      ></img>
                                    )}
                                    {obj?.fileInfo?.fileType === "png" && (
                                      <img
                                        src="/ContentM_images/PdfBlackIcon.svg"
                                        alt="sound logo"
                                        className="iconSTyl"
                                      ></img>
                                    )}
                                    {obj?.fileInfo?.fileType === "jpg" && (
                                      <img
                                        src="/ContentM_images/PdfBlackIcon.svg"
                                        alt="sound logo"
                                        className="iconSTyl"
                                      ></img>
                                    )}
                                    {obj?.fileInfo?.fileType === "svg" && (
                                      <img
                                        src="/ContentM_images/PdfBlackIcon.svg"
                                        alt="sound logo"
                                        className="iconSTyl"
                                      ></img>
                                    )}
                                    {obj?.fileInfo?.fileType === "video" && (
                                      <img
                                        src="/ContentM_images/PlayIcon.svg"
                                        alt="sound logo"
                                        className="iconSTyl"
                                      ></img>
                                    )}
                                    {obj?.fileInfo?.fileType === "mp4" && (
                                      <img
                                        src="/ContentM_images/PlayIcon.svg"
                                        alt="sound logo"
                                        className="iconSTyl"
                                      ></img>
                                    )}
                                    <div>
                                      <div
                                        className={
                                          clickedContent === obj
                                            ? "chapterDropdownDetailClicked"
                                            : "chapterDropdownDetail"
                                        }
                                      >
                                        {obj?.fileInfo?.fileName}
                                      </div>


                                      <div className="audio_list">
                                        {obj?.fileInfo?.fileType === "img" ||
                                          obj?.fileInfo?.fileType === "jpg" ||
                                          obj?.fileInfo?.fileType === "png"
                                          ? "image"
                                          : obj?.fileInfo?.fileType === "e-book"
                                            ? obj?.fileInfo?.fileLength
                                            : obj?.fileInfo?.fileType === "audio" ||
                                              obj?.fileInfo?.fileType === "video" ||
                                              obj?.fileInfo?.fileType === "mp4" ||
                                              obj?.fileInfo?.fileType === "mp3"
                                              ? formatSeconds(obj?.fileInfo?.fileLength)
                                              : obj?.fileInfo?.fileLength}{" "}
                                        {console.log("obj?.fileInfo?.fileLength", obj?.fileInfo?.fileLength)
                                        }
                                        {obj?.fileInfo?.fileType === "audio" &&
                                          "audio"}
                                        {obj?.fileInfo?.fileType === "mp3" &&
                                          "audio"}
                                        {obj?.fileInfo?.fileType === "video"}
                                        {obj?.fileInfo?.fileType === "mp4"}
                                        {obj?.fileInfo?.fileType === "pdf" &&
                                          "pages"}
                                        {obj?.fileInfo?.fileType === "e-book" &&
                                          "pages"}
                                        {console.log("bj?.fileInfo", obj?.fileInfo)}

                                        {/* {obj?.fileInfo?.fileType === "img" && " "}
                                        {obj?.fileInfo?.fileType === "jpg" && " "}
                                        {obj?.fileInfo?.fileType === "png" &&
                                          " "}{" "} */}
                                        {/* {obj?.fileInfo?.fileType === "img" ||
                                          obj?.fileInfo?.fileType === "jpg" ||
                                          obj?.fileInfo?.fileType === "png"
                                          ? " "
                                          : "Pages"}{" "} */}
                                        {/* {obj?.fileInfo?.fileType === "audio" &&
                                          "audio"}
                                        {obj?.fileInfo?.fileType === "mp3" &&
                                          "audio"}
                                        {obj?.fileInfo?.fileType === "video" &&
                                          "video"}
                                        {obj?.fileInfo?.fileType === "mp4" &&
                                          "video"}
                                        {obj?.fileInfo?.fileType === "pdf" &&
                                          "e-book"} */}
                                        {/* {obj?.fileInfo?.fileType === "img" &&
                                          "img"}
                                        {obj?.fileInfo?.fileType === "png" &&
                                          "img"}
                                        {obj?.fileInfo?.fileType === "jpg" &&
                                          "img"} */}
                                      </div>
                                      <div className="audio_list">{obj?.fileInfo?.author_name}</div>
                                    </div>
                                  </div>
                                </div>
                              )
                            )}
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>

        <div className="Video-player col-sm-7">
          {clickedContent?.fileInfo?.fileType === "pdf" ||
            clickedContent?.fileInfo?.fileType === "e-book" ? (
            <div className="pdf-canvas-containerBound">
              <div className="pdf-canvas-container2" id="fullScreenContent">
                <React.Fragment>
                  <div className="h-100">
                    {/* <div className="navigation-buttons">
                    <button
                      className="ml-2 nav_btn"
                      onClick={handlePreviousPage}
                      disabled={currentPage === 1}
                    >
                      Previous Page
                    </button>
                    <button
                      className="ml-2 nav_btn"
                      onClick={handleNextPage}
                      disabled={currentPage === numPages}
                    >
                      Next Page
                    </button>
                    <Button
                      className="ml-2 nav_btn"
                      onClick={() => {
                        handleBookmarkClick();
                        setAddBookmark(true);
                        setType("pdf");
                      }}
                    >
                      Bookmark
                    </Button>
                  </div> */}

                    {/* <div className="pdf-content">
                      <Document
                        file={helper(clickedContent?.fileInfo?.fileURL)}
                        onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                      >
                        <Page
                          pageNumber={currentPage}
                          renderTextLayer={false}
                        />
                      </Document>
                    </div> */}
                    <iframe
                      src={helper(clickedContent?.fileInfo?.fileURL)}
                      title="pdf"
                      className="w-full h-full"
                    />
                    {/* <Document
                      file={helper(clickedContent?.fileInfo?.fileURL)}
                      onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                    >
                      {Array.from(new Array(numPages), (el, index) => (
                        <React.Fragment key={`page_${index + 1}`}>
                          <Page pageNumber={index + 1} renderTextLayer={false} />
                          <p className="page-number">
                            Page {index + 1} of {numPages}
                          </p>
                        </React.Fragment>
                      ))}
                    </Document> */}
                  </div>
                </React.Fragment>
              </div>
              <div className="ContentBar">
                <p className="textInContentBar mt-2">
                  {clickedContent?.fileInfo?.fileName}
                </p>
                {/* <div className="page-number textInContentBar">
                  {currentPage}/{numPages}
                </div>
                {(clickedContent?.fileInfo?.fileType === "pdf" ||
                  clickedContent?.fileInfo?.fileType === "e-book") ? null : (<div className="d-flex gap-3">
                    <p
                      className="textInContentBar mt-2"
                      onClick={handlePreviousPage}
                    >
                      {"<"}{" "}
                    </p>
                    <p className="textInContentBar mt-2" onClick={handleNextPage}>
                      {">"}{" "}
                    </p>
                  </div>)} */}
                {(clickedContent?.fileInfo?.fileType === "pdf" ||
                  clickedContent?.fileInfo?.fileType === "e-book") ? null : (<div className="FlagAndFull">
                    <img
                      src={"/ContentM_images/BookmarkIcon.svg"}
                      className="ml-3 FlagIcon"
                      alt="flagIcon"
                      onClick={() => {
                        handleBookmarkClick();
                        setAddBookmark(true);
                        setType("pdf");
                      }}
                    ></img>
                  </div>)}
                <div className="FlagIcon-FullScreen">
                  <img
                    src={"/ContentM_images/FullScreen.svg"}
                    alt="fullScreenIcon"
                    className="ml-3"
                    onClick={() => toggleFullScreen()}
                  />
                </div>
              </div>
            </div>
          ) :
            <>
              <MediaRenderer
                clickedContent={clickedContent}
                contentProviderType={clickedContent?.fileInfo?.contentProviderID?.contentProviderType}
                playerRef={playerRef}
                handleUserLastSeen={handleUserLastSeen}
                setType={setType}
                setBookmarks={setBookmarks}
                handleBookmarkClick={handleBookmarkClick}
                handleTimeUpdate={handleTimeUpdate}
                handleTimeUpdateVdoCiphyer={handleTimeUpdateVdoCiphyer}
                helper={helper}
              />
            </>
            // clickedContent?.fileInfo?.fileType === "img" ||
            //   clickedContent?.fileInfo?.fileType === "png" ||
            //   clickedContent?.fileInfo?.fileType === "jpg" ? (
            //   <div className="pdf-canvas-container">
            //     <img
            //       src={helper(clickedContent?.fileInfo?.fileURL)}
            //       alt={clickedContent?.fileInfo?.fileName}
            //     />
            //   </div>
            // ) : (
            // <Player
            //   className="videoPlayer"
            //   ref={playerRef}
            //   src={helper(clickedContent?.fileInfo?.fileURL)}
            //   paused={true}
            // >
            //   <ControlBar>
            //     {/* <Button onClick={handleBookmarkClick}>Bookmark</Button> */}
            //     <img
            //       src={"/ContentM_images/FlagIcon.svg"}
            //       className="ml-3"
            //       alt="flagIcon"
            //       onClick={() => {
            //         handleBookmarkClick();
            //         setType("video");
            //       }}
            //     ></img>
            //   </ControlBar>
            // <video onTimeUpdate={handleTimeUpdate} />
            // </Player>
            // <div className="pdf-canvas-containerBound-video">
            //   <PlayerComponent
            //     handleUserLastSeen={handleUserLastSeen}
            //     ref={playerRef}
            //     setType={setType}
            //     setBookmarks={setBookmarks}
            //     handleBookmarkClick={handleBookmarkClick}
            //     handleTimeUpdate={handleTimeUpdate}
            //     key={clickedContent?.fileInfo?._id}
            //     videoId={clickedContent?.fileInfo?.videoID ? helper(clickedContent?.fileInfo?.videoID) : null}
            //   />
            // </div>
            // )
          }
          <div>
            <div className="five_component_CM" >
              <button
                className={
                  activeHeader === "Overview" ? "Four_btnActive" : "Four_btn_Content"
                }
                onClick={(e) => {
                  setActiveHeader("Overview");
                }}
              >
                Overview
              </button>
              <button
                className={
                  activeHeader === "Notes" ? "Four_btnActive" : "Four_btn_Content"
                }
                onClick={(e) => {
                  setActiveHeader("Notes");
                }}
              >
                My Notes
              </button>
              <button
                className={
                  activeHeader === "Bookmarks" ? "Four_btnActive" : "Four_btn_Content"
                }
                onClick={(e) => {
                  setActiveHeader("Bookmarks");
                }}
              >
                My Bookmarks
              </button>
              <button
                className={
                  activeHeader === "Queries" ? "Four_btnActive" : "Four_btn_Content"
                }
                onClick={(e) => {
                  setActiveHeader("Queries");
                }}
              >
                Queries
              </button>
              {
                clickedContent?.fileInfo?.fileType !== "e-book" && <div onClick={() => setAddBookmark(true)} style={{ color: "white", backgroundColor: "#003354", padding: "3px 5px", borderRadius: "8px", cursor: "pointer" }}>
                  <img
                    style={{ width: "20px", height: "20px" }}
                    src={"/ContentM_images/BookmarkIcon.svg"}
                    className=""
                    alt="flagIcon"
                    onClick={() => {
                      handleBookmarkClick();
                      setAddBookmark(true);
                      setType("video");
                    }}
                  ></img>
                </div>
              }
            </div>
            <div className="LibraryFourComponentContainer">
              {activeHeader === "Overview" && (
                <Overview
                  data={clickedContent}
                  book={clickedBook?.name}
                  chapter={clickedChapterName}
                />
              )}
              {activeHeader === "Notes" && (
                <Notes user={userDetail} content={clickedContent} />
              )}
              {activeHeader === "Bookmarks" && (
                <Bookmark
                  user={userDetail}
                  setComponentRerenderFlag={setComponentRerenderFlag}
                  componentRerenderFlag={componentRerenderFlag}
                  content={clickedContent}
                  book={clickedBook?.name}
                  chapter={clickedChapterName}
                  forward={handleJumpToTime}
                  setCurrentPage={setCurrentPage}
                />
              )}
              {activeHeader === "Queries" && (
                <div>
                  <BookMarkNote
                    userData={userDetail}
                    book={clickedBook}
                    setComponentRerenderFlag={setComponentRerenderFlag}
                    componentRerenderFlag={componentRerenderFlag}
                    chapter={clickedChapterId}
                    chapterName={clickedChapterName}
                    bookName={clickedBook?.name}
                    clickedSubjectId={clickedSubjectId}
                    grpId={groupId}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <div className="mt-4">
        <div className="OtherBooks">View other books of this Subject</div>
        <div className="gap-4 d-flex p-4">
          {chapters?.length > 0 &&
            chapters
              ?.filter(
                (item, indexToRemove) => indexToRemove.toString() !== index
              )
              ?.map((obj, index) => (
                <div
                  onClick={() => {
                    window.history.back();
                    handleUserLastSeen();
                  }}
                >
                  <img
                    src={
                      obj.thumbnailImage
                        ? IP + obj.thumbnailImage.replace(/^\./, "")
                        : "/LibraryImg/LibrarySubjectImg.svg "
                    }
                    alt="Book img"
                    className="imageSize imgAlignment"
                  ></img>
                  <h1 className="BookHeading" title={obj?.name}>
                    {obj?.name}
                  </h1>
                </div>
              ))}
          
        </div>
      </div> */}
      {
        openSubject.deletePopupNote && (
          <DeletePopup
            handleCloseNoteDeltePopup={handleCloseNoteDeltePopup}
            data={clickedNote}
            userData={userDetail}
            contentId={clickedContent?.id}
          />
        )
      }
      {
        openSubject.deletePopupBookmark && (
          <DeleteBookmark
            handleCloseBookmarkDeltePopup={handleCloseBookmarkDeltePopup}
            data={clickedBookmark}
            userData={userDetail}
            contentId={clickedContent?.id}
          />
        )
      }
      {
        openSubject.editeNotePopUp && (
          <EditNotePopup
            handleCloseNoteEditPopup={handleCloseNoteEditPopup}
            data={clickedNote}
            userData={userDetail}
            contentId={clickedContent?.id}
          />
        )
      }
      {
        addBookmark && (
          <AddBookmark
            close={() => {
              setAddBookmark(false);
            }}
            setComponentRerenderFlag={setComponentRerenderFlag}
            bookMarkTime={type === "video" ? bookmarks : currentPage}
            userData={userDetail}
            contentId={clickedContent?.id}
          />
        )
      }
      {openQuizPopup && <QuizPopup setOpenQuizPopup={setOpenQuizPopup} />}
    </div>
  );
}
